(function () {
  'use strict';

  /* =========================================================
     0. Utilities
  ========================================================= */
  function formatMoney(cents) {
    var n = (parseInt(cents, 10) || 0) / 100;
    return '$' + n.toFixed(2);
  }

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* =========================================================
     1. Generic modal system
  ========================================================= */
  var openModalCount = 0;

  function openModal(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.classList.add('is-open');
    openModalCount++;
    document.body.classList.add('sorenaq-lock-scroll');

    if (id === 'sorenaq-cart-drawer') {
      refreshCartDrawer();
    }
    if (id === 'sorenaq-cadence-modal') {
      Cadence.onModalOpen();
    } else {
      Cadence.onModalClose(); // stop the ticking clock while it's not visible
    }
  }

  function closeModal(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.classList.remove('is-open');
    openModalCount = Math.max(0, openModalCount - 1);
    if (openModalCount === 0) document.body.classList.remove('sorenaq-lock-scroll');
    if (id === 'sorenaq-cadence-modal') Cadence.onModalClose();
  }

  document.addEventListener('click', function (e) {
    var openTrigger = e.target.closest('[data-open-modal]');
    if (openTrigger) {
      e.preventDefault();
      openModal(openTrigger.getAttribute('data-open-modal'));
      return;
    }
    var closeTrigger = e.target.closest('[data-close-modal]');
    if (closeTrigger) {
      e.preventDefault();
      closeModal(closeTrigger.getAttribute('data-close-modal'));
      return;
    }
    var alertLink = e.target.closest('.sorenaq-alert-link');
    if (alertLink) {
      e.preventDefault();
      window.alert(alertLink.getAttribute('data-alert-message') || '');
    }
  });

  /* =========================================================
     2. Navbar "ADQUIRIR" -> scroll to buy bar, or open cart
  ========================================================= */
  var scrollBtn = document.getElementById('sorenaq-scroll-to-buy');
  if (scrollBtn) {
    scrollBtn.addEventListener('click', function () {
      var el = document.getElementById('purchase-actions');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        openModal('sorenaq-cart-drawer');
      }
    });
  }

  /* =========================================================
     3. Quantity steppers (Hero) — mobile + desktop kept in sync
  ========================================================= */
  var qty = 1;
  function renderQty() {
    qsa('.js-qty-display').forEach(function (el) { el.textContent = qty; });
  }
  qsa('[data-qty-wrapper]').forEach(function (wrap) {
    var inc = wrap.querySelector('[data-qty-inc]');
    var dec = wrap.querySelector('[data-qty-dec]');
    if (inc) inc.addEventListener('click', function () { qty = Math.min(qty + 1, 10); renderQty(); });
    if (dec) dec.addEventListener('click', function () { qty = Math.max(qty - 1, 1); renderQty(); });
  });

  /* =========================================================
     4. Perspective switcher: curved arc slider (Hero) +
     Inspection modal carousel share the same state
  ========================================================= */
  var PERSPECTIVE_KEYS = ['perfil', 'frontal', 'valvula', 'despiece'];
  var PERSPECTIVES = {
    perfil: {
      label: 'Perfil 45°',
      badge: 'MODELO EXACTO — PERSPECTIVA SAGITAL',
      shortBadge: 'PERSPECTIVA SAGITAL',
      description: 'Boquilla de silicona con alas de micropuntos, collarín estriado y dial cilíndrico ranurado con indicador rotativo.'
    },
    frontal: {
      label: 'Frontal',
      badge: 'ALINEACIÓN AXIAL SIMÉTRICA',
      shortBadge: 'ALINEACIÓN AXIAL SIMÉTRICA',
      description: 'Apertura en U de doble aleta con relieve táctil para mordida anatómica sin presión dental excesiva.'
    },
    valvula: {
      label: 'Válvula',
      badge: 'DIAL ROTATIVO (+ / -)',
      shortBadge: 'DIAL ROTATIVO (+ / -)',
      description: 'Tapa circular con flecha de rotación serigrafiada y estrías cilíndricas para calibración precisa del flujo inspiratorio.'
    },
    despiece: {
      label: 'Despiece',
      badge: 'SISTEMA MODULAR DE 3 COMPONENTES',
      shortBadge: 'SISTEMA MODULAR DE 3 COMPONENTES',
      description: 'Boquilla anatómica flexible, núcleo roscado interior con micro-estrías y cilindro exterior de ajuste micrométrico.'
    }
  };

  var currentPerspective = 'perfil';

  function imageForPerspective(id) {
    var mainImg = document.getElementById('sorenaq-hero-main-image');
    if (!mainImg) return '';
    return mainImg.getAttribute('data-img-' + id) || '';
  }

  function bezierCoords(t) {
    t = Math.max(0, Math.min(1, t));
    var invT = 1 - t;
    var x = invT * invT * 24 + 2 * invT * t * 170 + t * t * 316;
    var y = invT * invT * 10 + 2 * invT * t * 46 + t * t * 10;
    return { xPct: (x / 340) * 100, yPct: (y / 50) * 100 };
  }

  function setPerspective(id, opts) {
    if (!PERSPECTIVES[id]) return;
    currentPerspective = id;
    var data = PERSPECTIVES[id];
    var imgUrl = imageForPerspective(id);
    var idx = PERSPECTIVE_KEYS.indexOf(id);

    // Hero main image
    var mainImg = document.getElementById('sorenaq-hero-main-image');
    if (mainImg && imgUrl) mainImg.setAttribute('src', imgUrl);

    // Hotspots only make sense on "perfil"
    var hotspotsWrap = document.getElementById('sorenaq-hero-hotspots');
    if (hotspotsWrap) hotspotsWrap.style.display = (id === 'perfil') ? '' : 'none';

    // Compact label under the arc slider
    var indexEl = document.getElementById('sorenaq-arc-index');
    var labelEl = document.getElementById('sorenaq-arc-label');
    var badgeEl = document.getElementById('sorenaq-arc-badge');
    var descEl = document.getElementById('sorenaq-arc-description');
    if (indexEl) indexEl.textContent = '0' + (idx + 1) + ' / 04';
    if (labelEl) labelEl.textContent = data.label;
    if (badgeEl) badgeEl.textContent = data.shortBadge;
    if (descEl) descEl.textContent = data.description;

    // Arc slider visual state: handle position + tick styles + nav buttons
    if (!(opts && opts.skipArcSync)) {
      Arc.syncToIndex(idx);
    }

    // Inspection modal
    qsa('.sorenaq-inspect-persp-btn').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-inspect-perspective') === id);
    });
    var inspectImg = document.getElementById('sorenaq-inspect-image');
    if (inspectImg && imgUrl) inspectImg.setAttribute('src', imgUrl);
    var inspectCaption = document.getElementById('sorenaq-inspect-caption');
    if (inspectCaption) inspectCaption.textContent = data.badge + ' // ' + data.label;
    var inspectTitle = document.getElementById('sorenaq-inspect-title');
    if (inspectTitle) inspectTitle.textContent = data.label + ' — Detalle Clínico';
    var inspectDescription = document.getElementById('sorenaq-inspect-description');
    if (inspectDescription) inspectDescription.textContent = data.description;

    if (opts && opts.resetZoom) Inspection.resetZoom();
  }

  qsa('.sorenaq-inspect-persp-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      setPerspective(btn.getAttribute('data-inspect-perspective'), { resetZoom: true });
    });
  });

  /* --- Arc slider: drag / click / touch-swipe, all mapped onto the
     same quadratic bezier the design uses --- */
  var Arc = (function () {
    var track = document.getElementById('sorenaq-arc-track');
    var handle = document.getElementById('sorenaq-arc-handle');
    var prevBtn = document.getElementById('sorenaq-arc-prev');
    var nextBtn = document.getElementById('sorenaq-arc-next');
    if (!track || !handle) return { syncToIndex: function () {} };

    var isDragging = false;

    function positionHandle(t) {
      var c = bezierCoords(t);
      handle.style.left = c.xPct + '%';
      handle.style.top = c.yPct + '%';
    }

    function setTicks(activeIdx) {
      for (var i = 0; i < 4; i++) {
        var g = document.getElementById('sorenaq-arc-tick-' + i);
        if (!g) continue;
        var dot = g.querySelector('circle:not(.sorenaq-arc-tick-ring)');
        var ring = g.querySelector('.sorenaq-arc-tick-ring');
        var isActive = i === activeIdx;
        if (dot) {
          dot.setAttribute('r', isActive ? '3.5' : '2');
          dot.setAttribute('fill', isActive ? '#00FF66' : 'rgba(255,255,255,0.5)');
        }
        if (ring) ring.setAttribute('opacity', isActive ? '0.6' : '0');
      }
    }

    function syncToIndex(idx) {
      positionHandle(idx / 3);
      setTicks(idx);
      handle.setAttribute('aria-valuenow', idx);
      handle.setAttribute('aria-valuetext', PERSPECTIVES[PERSPECTIVE_KEYS[idx]].label);
      if (prevBtn) prevBtn.disabled = idx === 0;
      if (nextBtn) nextBtn.disabled = idx === 3;
    }

    function updateFromClientX(clientX, snap) {
      var rect = track.getBoundingClientRect();
      var rawT = (clientX - rect.left) / rect.width;
      var clampedT = Math.max(0, Math.min(1, rawT));
      var targetIdx = Math.max(0, Math.min(3, Math.round(clampedT * 3)));

      if (snap) {
        positionHandle(targetIdx / 3);
        setTicks(targetIdx);
      } else {
        positionHandle(clampedT);
      }
      var targetId = PERSPECTIVE_KEYS[targetIdx];
      if (targetId !== currentPerspective) {
        setPerspective(targetId, { skipArcSync: true });
        setTicks(targetIdx);
      }
      if (prevBtn) prevBtn.disabled = targetIdx === 0;
      if (nextBtn) nextBtn.disabled = targetIdx === 3;
      return targetIdx;
    }

    handle.addEventListener('pointerdown', function (e) {
      e.preventDefault();
      isDragging = true;
      handle.classList.add('is-dragging');
      try { handle.setPointerCapture(e.pointerId); } catch (err) {}
      updateFromClientX(e.clientX, false);
    });
    handle.addEventListener('pointermove', function (e) {
      if (!isDragging) return;
      updateFromClientX(e.clientX, false);
    });
    function endDrag(e) {
      if (!isDragging) return;
      isDragging = false;
      handle.classList.remove('is-dragging');
      try { handle.releasePointerCapture(e.pointerId); } catch (err) {}
      var idx = updateFromClientX(e.clientX, true);
      syncToIndex(idx);
    }
    handle.addEventListener('pointerup', endDrag);
    handle.addEventListener('pointercancel', endDrag);

    track.addEventListener('click', function (e) {
      if (isDragging) return;
      var idx = updateFromClientX(e.clientX, true);
      syncToIndex(idx);
    });

    if (prevBtn) prevBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var idx = Math.max(0, PERSPECTIVE_KEYS.indexOf(currentPerspective) - 1);
      setPerspective(PERSPECTIVE_KEYS[idx]);
    });
    if (nextBtn) nextBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var idx = Math.min(3, PERSPECTIVE_KEYS.indexOf(currentPerspective) + 1);
      setPerspective(PERSPECTIVE_KEYS[idx]);
    });

    return { syncToIndex: syncToIndex };
  })();

  /* --- Touch swipe directly on the product image --- */
  (function () {
    var stage = document.getElementById('sorenaq-product-stage');
    if (!stage) return;
    var touchStartX = null;
    stage.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    });
    stage.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var deltaX = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(deltaX) > 35) {
        var idx = PERSPECTIVE_KEYS.indexOf(currentPerspective);
        if (deltaX > 0) idx = Math.max(0, idx - 1);
        else idx = Math.min(3, idx + 1);
        setPerspective(PERSPECTIVE_KEYS[idx]);
      }
      touchStartX = null;
    });
  })();

  /* =========================================================
     5. Resistance dial tuner (Hero) — cosmetic, matches original
  ========================================================= */
  var DIAL_MODE = function (lvl) {
    if (lvl <= 2) return 'Adaptación / Calentamiento';
    if (lvl <= 4) return 'Potencia Diafragmática';
    return 'Capacidad Hipóxica Élite';
  };
  qsa('.sorenaq-dial-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var lvl = parseInt(btn.getAttribute('data-level'), 10);
      qsa('.sorenaq-dial-btn').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      var labelEl = document.getElementById('sorenaq-dial-level-label');
      var pressureEl = document.getElementById('sorenaq-dial-pressure');
      var modeEl = document.getElementById('sorenaq-dial-mode');
      if (labelEl) labelEl.textContent = 'DIAL: NIVEL ' + lvl + ' / 6';
      if (pressureEl) pressureEl.textContent = (lvl * 20) + ' cmH₂O';
      if (modeEl) modeEl.textContent = DIAL_MODE(lvl);
    });
  });

  /* =========================================================
     6. Hotspot tooltips — click toggle (desktop also gets CSS hover)
  ========================================================= */
  qsa('.hotspot').forEach(function (hotspot) {
    hotspot.querySelector('button').addEventListener('click', function () {
      var wasOpen = hotspot.classList.contains('is-open');
      qsa('.hotspot').forEach(function (h) { h.classList.remove('is-open'); });
      if (!wasOpen) hotspot.classList.add('is-open');
    });
  });

  /* =========================================================
     7. FAQ accordion — single item open at a time
  ========================================================= */
  qsa('.sorenaq-faq-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.sorenaq-faq-item');
      var wasOpen = item.classList.contains('is-open');
      qsa('.sorenaq-faq-item').forEach(function (i) {
        i.classList.remove('is-open');
        i.querySelector('.sorenaq-faq-toggle').setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* =========================================================
     7b. Materials section: macro mode switcher + hotspots
  ========================================================= */
  (function () {
    var img = document.getElementById('sorenaq-macro-image');
    if (!img) return;
    var mobileOverlay = document.getElementById('sorenaq-macro-mobile-overlay');
    var mobileTag = document.getElementById('sorenaq-macro-mobile-tag');
    var mobileTitle = document.getElementById('sorenaq-macro-mobile-title');
    var mobileDesc = document.getElementById('sorenaq-macro-mobile-desc');

    var HOTSPOT_INFO = {
      silicone: { tag: 'SILICONA QUIRÚRGICA USP VI', title: 'Boquilla Anatómica con Micropuntos', description: 'Silicona médica elastomérica inerte (ISO 10993). Matriz de micro-puntos de retención para mordida firme sin fatiga dental.' },
      seal: { tag: 'TOLERANCIA 0.05MM', title: 'Corona de Acople Hermético', description: 'Sellado estanco micrométrico que canaliza el 100% del gradiente inspiratorio sin pérdidas de presión negativa.' },
      dial: { tag: 'DIAL COMPACTO 2.8 CM', title: 'Selector de Intensidad Micrométrico', description: 'Cuerpo cilíndrico ultra-compacto de 28 mm con 6 estrías de alta fricción. Calibración gradual de flujo (+ / -) sin volumen excesivo.' }
    };

    function setActiveHotspot(id) {
      qsa('.sorenaq-macro-hotspot').forEach(function (h) {
        h.classList.toggle('is-active', h.getAttribute('data-hotspot') === id);
      });
      if (id && mobileOverlay) {
        var info = HOTSPOT_INFO[id];
        if (info) {
          if (mobileTag) mobileTag.textContent = info.tag;
          if (mobileTitle) mobileTitle.textContent = info.title;
          if (mobileDesc) mobileDesc.textContent = info.description;
        }
        mobileOverlay.classList.remove('hidden');
      } else if (mobileOverlay) {
        mobileOverlay.classList.add('hidden');
      }
    }

    qsa('.sorenaq-macro-hotspot').forEach(function (h) {
      h.querySelector('button').addEventListener('click', function () {
        var id = h.getAttribute('data-hotspot');
        var wasActive = h.classList.contains('is-active');
        setActiveHotspot(wasActive ? null : id);
      });
    });

    qsa('.sorenaq-macro-mode-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mode = btn.getAttribute('data-macro-mode');
        qsa('.sorenaq-macro-mode-btn').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        var newSrc = img.getAttribute('data-img-' + mode);
        if (newSrc) img.setAttribute('src', newSrc);

        var hotspotsWrap = document.getElementById('sorenaq-macro-hotspots');
        if (mode === 'general') {
          if (hotspotsWrap) hotspotsWrap.style.display = '';
          setActiveHotspot(null);
        } else {
          if (hotspotsWrap) hotspotsWrap.style.display = 'none';
          setActiveHotspot(mode === 'silicone' ? 'silicone' : 'dial');
          if (mobileOverlay) mobileOverlay.classList.add('hidden');
        }
      });
    });
  })();

  /* =========================================================
     8. Cadence breathing modal
  ========================================================= */
  var Cadence = (function () {
    var isActive = false;
    var phase = 'inhale';
    var counter = 4;
    var cycle = 1;
    var soundEnabled = true;
    var resistance = 3;
    var timer = null;

    var CONFIG = {
      'inhale': { label: 'INHALA PROFUNDO', instruction: 'Fuerza diafragmática contra resistencia Sorenaq', scale: 'scale-125' },
      'hold-in': { label: 'SOSTÉN (APNEA)', instruction: 'Expansión alveolar y difusión capilar', scale: 'scale-110' },
      'exhale': { label: 'EXHALA SUAVE', instruction: 'Relajación controlada de la caja torácica', scale: 'scale-95' },
      'hold-out': { label: 'VACÍO', instruction: 'Reinicio neuromuscular antes del siguiente ciclo', scale: 'scale-90' }
    };
    var SCALE_CLASSES = ['scale-125', 'scale-110', 'scale-95', 'scale-90', 'scale-100'];

    function render() {
      var outer = document.getElementById('sorenaq-cadence-ring-outer');
      var inner = document.getElementById('sorenaq-cadence-ring-inner');
      var counterEl = document.getElementById('sorenaq-cadence-counter');
      var labelEl = document.getElementById('sorenaq-cadence-phase-label');
      var instructionEl = document.getElementById('sorenaq-cadence-instruction');
      var cycleEl = document.getElementById('sorenaq-cadence-cycle');
      var resistanceEl = document.getElementById('sorenaq-cadence-resistance');
      var playBtn = document.getElementById('sorenaq-cadence-play-btn');
      var soundBtn = document.getElementById('sorenaq-cadence-sound-btn');
      var cfg = CONFIG[phase];

      [outer, inner].forEach(function (el) {
        if (!el) return;
        SCALE_CLASSES.forEach(function (c) { el.classList.remove(c); });
        el.classList.add(isActive ? cfg.scale : 'scale-100');
      });

      if (counterEl) counterEl.textContent = isActive ? String(counter).padStart(2, '0') : '04';
      if (labelEl) labelEl.textContent = isActive ? cfg.label : 'LISTO';
      if (instructionEl) instructionEl.textContent = isActive ? cfg.instruction : 'Pulsa INICIAR para comenzar la serie guiada de 30 ciclos';
      if (cycleEl) cycleEl.textContent = cycle + ' / 30';
      if (resistanceEl) resistanceEl.textContent = 'NIVEL ' + resistance + ' (' + (resistance * 20) + ' cmH₂O)';

      if (playBtn) playBtn.classList.toggle('is-active', isActive);
      qsa('.sorenaq-cadence-dial-btn').forEach(function (b) {
        b.classList.toggle('is-active', parseInt(b.getAttribute('data-cadence-level'), 10) === resistance);
      });
      if (soundBtn) soundBtn.classList.toggle('is-muted', !soundEnabled);
      var playLabel = qs('.sorenaq-cadence-play-label');
      if (playLabel) playLabel.textContent = isActive ? 'PAUSAR' : 'INICIAR SESIÓN';
    }

    function tick() {
      if (counter > 1) {
        counter -= 1;
      } else if (phase === 'inhale') {
        phase = 'hold-in'; counter = 2;
      } else if (phase === 'hold-in') {
        phase = 'exhale'; counter = 4;
      } else if (phase === 'exhale') {
        phase = 'hold-out'; counter = 2;
      } else {
        phase = 'inhale'; cycle = Math.min(cycle + 1, 30); counter = 4;
      }
      render();
    }

    function startTimer() {
      stopTimer();
      timer = setInterval(tick, 1000);
    }
    function stopTimer() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function bind() {
      var playBtn = document.getElementById('sorenaq-cadence-play-btn');
      var resetBtn = document.getElementById('sorenaq-cadence-reset-btn');
      var soundBtn = document.getElementById('sorenaq-cadence-sound-btn');
      if (playBtn) playBtn.addEventListener('click', function () {
        isActive = !isActive;
        if (isActive) startTimer(); else stopTimer();
        render();
      });
      if (resetBtn) resetBtn.addEventListener('click', function () {
        isActive = false; phase = 'inhale'; counter = 4; cycle = 1;
        stopTimer();
        render();
      });
      if (soundBtn) soundBtn.addEventListener('click', function () {
        soundEnabled = !soundEnabled;
        render();
      });
      qsa('.sorenaq-cadence-dial-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          resistance = parseInt(btn.getAttribute('data-cadence-level'), 10);
          render();
        });
      });
      var openCadenceFromProtocol = document.getElementById('sorenaq-protocol-open-cadence');
      if (openCadenceFromProtocol) openCadenceFromProtocol.addEventListener('click', function () {
        closeModal('sorenaq-protocol-modal');
        openModal('sorenaq-cadence-modal');
      });
      render();
    }

    return {
      bind: bind,
      onModalOpen: function () { if (isActive) startTimer(); },
      onModalClose: function () { stopTimer(); }
    };
  })();
  Cadence.bind();

  /* =========================================================
     9. Inspection modal — zoom controls + hotspot list
  ========================================================= */
  var Inspection = (function () {
    var zoom = 1;
    function render() {
      var wrap = document.getElementById('sorenaq-inspect-zoom-wrap');
      var label = document.getElementById('sorenaq-inspect-zoom-label');
      var zoomOutBtn = document.getElementById('sorenaq-inspect-zoom-out');
      var zoomInBtn = document.getElementById('sorenaq-inspect-zoom-in');
      if (wrap) wrap.style.transform = 'scale(' + zoom + ')';
      if (label) label.textContent = Math.round(zoom * 100) + '%';
      if (zoomOutBtn) zoomOutBtn.disabled = zoom <= 1;
      if (zoomInBtn) zoomInBtn.disabled = zoom >= 2.5;
    }
    function bind() {
      var zoomIn = document.getElementById('sorenaq-inspect-zoom-in');
      var zoomOut = document.getElementById('sorenaq-inspect-zoom-out');
      var zoomReset = document.getElementById('sorenaq-inspect-zoom-reset');
      if (zoomIn) zoomIn.addEventListener('click', function () { zoom = Math.min(zoom + 0.5, 2.5); render(); });
      if (zoomOut) zoomOut.addEventListener('click', function () { zoom = Math.max(zoom - 0.5, 1); render(); });
      if (zoomReset) zoomReset.addEventListener('click', function () { zoom = 1; render(); });

      qsa('.sorenaq-inspect-hotspot').forEach(function (item) {
        item.addEventListener('click', function () {
          qsa('.sorenaq-inspect-hotspot').forEach(function (i) { i.classList.remove('is-active'); });
          item.classList.add('is-active');
        });
      });
      render();
    }
    return { bind: bind, resetZoom: function () { zoom = 1; render(); } };
  })();
  Inspection.bind();

  /* =========================================================
     10. Real Shopify cart + native checkout
  ========================================================= */
  var buyBtn = document.getElementById('sorenaq-buy-now-btn');
  var trackedVariantId = buyBtn ? buyBtn.getAttribute('data-variant-id') : null;
  var trackedCompareCents = buyBtn ? parseInt(buyBtn.getAttribute('data-compare-cents'), 10) || 0 : 0;
  var trackedPriceCents = buyBtn ? parseInt(buyBtn.getAttribute('data-price-cents'), 10) || 0 : 0;

  /* ---------------------------------------------------------
     10a. Color swatch selector (only present if the connected
     product has a color-like option)
  --------------------------------------------------------- */
  (function () {
    var dataEl = document.getElementById('sorenaq-color-data');
    if (!dataEl) return;
    var colorData;
    try { colorData = JSON.parse(dataEl.textContent).values; } catch (e) { return; }

    function findColor(value) {
      for (var i = 0; i < colorData.length; i++) {
        if (colorData[i].value === value) return colorData[i];
      }
      return null;
    }

    function updateEditionUI(value, hexColor) {
      var editionName = document.getElementById('sorenaq-edition-name');
      var editionDot = document.getElementById('sorenaq-edition-dot');
      if (editionName) editionName.textContent = value;
      if (editionDot && hexColor) editionDot.style.backgroundColor = hexColor;
      qsa('.sorenaq-edition-tag-name').forEach(function (el) { el.textContent = value; });
      qsa('.sorenaq-edition-tag-dot').forEach(function (el) { if (hexColor) el.style.backgroundColor = hexColor; });
    }

    function selectColor(value) {
      var color = findColor(value);
      if (!color) return;

      qsa('.sorenaq-swatch').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-color-value') === value);
      });
      var nameEl = document.getElementById('sorenaq-color-name');
      if (nameEl) nameEl.textContent = value;
      var previewEl = qs('.sorenaq-swatch-preview');
      var activeSwatch = qs('.sorenaq-swatch[data-color-value="' + value + '"]');
      if (previewEl && activeSwatch) previewEl.style.backgroundColor = activeSwatch.style.backgroundColor;
      var availabilityEl = document.getElementById('sorenaq-color-availability');
      if (availabilityEl) availabilityEl.textContent = color.available ? 'Disponible' : 'Agotado temporalmente';
      updateEditionUI(value, activeSwatch ? activeSwatch.style.backgroundColor : null);

      // Update tracked variant + buy button
      trackedVariantId = color.variantId;
      trackedPriceCents = color.priceCents;
      trackedCompareCents = color.compareCents;
      if (buyBtn) {
        buyBtn.setAttribute('data-variant-id', color.variantId);
        buyBtn.setAttribute('data-price-cents', color.priceCents);
        buyBtn.setAttribute('data-compare-cents', color.compareCents);
        buyBtn.disabled = !color.available;
        buyBtn.classList.toggle('opacity-50', !color.available);
        buyBtn.classList.toggle('cursor-not-allowed', !color.available);
      }

      // Update price display
      var amountEl = document.getElementById('sorenaq-price-amount');
      if (amountEl) amountEl.textContent = (color.priceCents / 100).toFixed(2);
      var compareRow = document.getElementById('sorenaq-price-compare-row');
      var compareEl = document.getElementById('sorenaq-price-compare');
      var badgeEl = document.getElementById('sorenaq-price-discount-badge');
      if (color.compareCents > color.priceCents) {
        if (compareRow) compareRow.classList.remove('hidden');
        if (compareEl) compareEl.textContent = (color.compareCents / 100).toFixed(2);
        if (badgeEl) {
          var pct = Math.round(((color.compareCents - color.priceCents) / color.compareCents) * 100);
          badgeEl.textContent = '-' + pct + '% ATELIER';
        }
      } else if (compareRow) {
        compareRow.classList.add('hidden');
      }
    }

    qsa('.sorenaq-swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectColor(btn.getAttribute('data-color-value'));
      });
    });

    // Initialize preview dot + availability text for the first (already-active) swatch
    var firstActive = qs('.sorenaq-swatch.is-active');
    if (firstActive) {
      updateEditionUI(firstActive.getAttribute('data-color-value'), firstActive.style.backgroundColor);
    }
  })();

  function updateCartCount(count) {
    var badge = document.getElementById('sorenaq-cart-count');
    var iconBtn = document.getElementById('sorenaq-cart-icon-btn');
    if (badge) badge.textContent = count;
    if (iconBtn) iconBtn.classList.toggle('hidden', count === 0);
  }

  function setCartLineQuantity(variantId, quantity) {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var existingIndex = -1;
        cart.items.forEach(function (item, idx) {
          if (String(item.variant_id) === String(variantId)) existingIndex = idx;
        });
        if (existingIndex === -1) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: quantity })
          }).then(function (r) { return r.json(); });
        }
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: existingIndex + 1, quantity: quantity })
        }).then(function (r) { return r.json(); });
      });
  }

  function renderCartDrawer(cart) {
    var itemsWrap = document.getElementById('sorenaq-cart-items');
    var emptyEl = document.getElementById('sorenaq-cart-empty');
    var summaryEl = document.getElementById('sorenaq-cart-summary');
    if (!itemsWrap) return;

    if (!cart.items.length) {
      itemsWrap.innerHTML = '';
      if (emptyEl) emptyEl.classList.remove('hidden');
      if (emptyEl) emptyEl.classList.add('flex');
      if (summaryEl) summaryEl.classList.add('hidden');
      var checkoutBtn = document.getElementById('sorenaq-cart-checkout-btn');
      if (checkoutBtn) checkoutBtn.classList.add('hidden');
      updateCartCount(0);
      return;
    }

    if (emptyEl) { emptyEl.classList.add('hidden'); emptyEl.classList.remove('flex'); }
    if (summaryEl) summaryEl.classList.remove('hidden');
    var checkoutBtnEl = document.getElementById('sorenaq-cart-checkout-btn');
    if (checkoutBtnEl) checkoutBtnEl.classList.remove('hidden');

    var html = '';
    var totalCompare = 0;
    cart.items.forEach(function (item) {
      var img = item.image || '';
      html += '' +
        '<div class="p-4 rounded-2xl bg-[#121212] border border-white/10 flex items-center gap-4 mb-3">' +
        '  <div class="w-16 h-16 rounded-xl bg-[#1a1a1a] p-1.5 flex items-center justify-center shrink-0 border border-white/5">' +
        (img ? '<img src="' + img + '" alt="' + item.product_title.replace(/"/g, '&quot;') + '" class="w-full h-full object-contain">' : '') +
        '  </div>' +
        '  <div class="flex-1 min-w-0">' +
        '    <h4 class="text-sm font-semibold text-white truncate font-serif">' + item.product_title + '</h4>' +
        '    <p class="text-xs text-[#849581] font-mono">Cantidad: ' + item.quantity + (item.variant_title ? ' · ' + item.variant_title : '') + '</p>' +
        '    <div class="flex items-center gap-2 mt-1">' +
        '      <span class="text-sm font-mono font-bold text-[#00FF66]">' + formatMoney(item.line_price) + ' ' + (cart.currency || 'MXN') + '</span>' +
        '    </div>' +
        '  </div>' +
        '  <button type="button" class="sorenaq-cart-remove-btn w-8 h-8 rounded-full bg-white/5 hover:bg-white/10 text-[#849581] hover:text-white flex items-center justify-center shrink-0 transition-colors cursor-pointer" data-remove-variant="' + item.variant_id + '" aria-label="Quitar producto" title="Quitar del carrito">' +
        '    <svg viewBox="0 0 24 24" class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>' +
        '  </button>' +
        '</div>';

      if (String(item.variant_id) === String(trackedVariantId) && trackedCompareCents > trackedPriceCents) {
        totalCompare += trackedCompareCents * item.quantity;
      }
    });
    itemsWrap.innerHTML = html;

    qsa('.sorenaq-cart-remove-btn', itemsWrap).forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.disabled = true;
        var variantId = btn.getAttribute('data-remove-variant');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 0 })
        })
          .then(function () { return fetch('/cart.js'); })
          .then(function (r) { return r.json(); })
          .then(renderCartDrawer)
          .catch(function () { btn.disabled = false; });
      });
    });

    var subtotalEl = document.getElementById('sorenaq-cart-subtotal');
    var discountRow = document.getElementById('sorenaq-cart-discount-row');
    var discountEl = document.getElementById('sorenaq-cart-discount');
    var totalEl = document.getElementById('sorenaq-cart-total');

    if (subtotalEl) subtotalEl.textContent = formatMoney(totalCompare > 0 ? totalCompare : cart.total_price) + ' ' + (cart.currency || 'MXN');
    if (totalCompare > cart.total_price && discountRow && discountEl) {
      discountRow.classList.remove('hidden');
      discountRow.classList.add('flex');
      discountEl.textContent = '-' + formatMoney(totalCompare - cart.total_price) + ' ' + (cart.currency || 'MXN');
    } else if (discountRow) {
      discountRow.classList.add('hidden');
      discountRow.classList.remove('flex');
    }
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price) + ' ' + (cart.currency || 'MXN');

    var checkoutLabel = document.getElementById('sorenaq-cart-checkout-label');
    if (checkoutLabel) checkoutLabel.textContent = 'CONFIRMAR Y ADQUIRIR — ' + formatMoney(cart.total_price) + ' ' + (cart.currency || 'MXN');

    updateCartCount(cart.item_count);
  }

  function refreshCartDrawer() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCartDrawer);
  }

  if (buyBtn) {
    buyBtn.addEventListener('click', function () {
      if (!trackedVariantId || trackedVariantId === '') {
        window.alert('Este producto todavía no está conectado. Ve al editor de temas y selecciona el producto de Sorenaq en la sección "Hero".');
        return;
      }
      setCartLineQuantity(trackedVariantId, qty).then(function () {
        var toast = document.getElementById('sorenaq-added-toast');
        var toastMsg = document.getElementById('sorenaq-toast-message');
        if (toastMsg) {
          var colorNameEl = document.getElementById('sorenaq-color-name');
          var colorSuffix = colorNameEl ? ' (' + colorNameEl.textContent + ')' : '';
          toastMsg.textContent = 'Agregado al pedido' + colorSuffix + ' · Despacho prioritario activado';
        }
        if (toast) {
          toast.classList.remove('hidden');
          toast.classList.add('flex');
          setTimeout(function () {
            toast.classList.add('hidden');
            toast.classList.remove('flex');
          }, 3000);
        }
        openModal('sorenaq-cart-drawer');
      }).catch(function () {
        window.alert('No se pudo agregar el producto al carrito. Intenta de nuevo.');
      });
    });
  }

  var cartCheckoutBtn = document.getElementById('sorenaq-cart-checkout-btn');
  if (cartCheckoutBtn) {
    cartCheckoutBtn.addEventListener('click', function () {
      window.location.href = '/checkout';
    });
  }

  // Initial cart count on page load (server-rendered value is already correct,
  // this just keeps things in sync if the cart changed in another tab).
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
    updateCartCount(cart.item_count);
  }).catch(function () {});

})();

